import { render } from "./sf-select2.vue?vue&type=template&id=07c03212"
import script from "./sf-select2.vue?vue&type=script&lang=js"
export * from "./sf-select2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__